import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { ApplyPanel } from './ApplyPanel';
import { DiffPanel } from './DiffPanel';
import type { EnvSchema } from './EnvSelector';
import { OverridePanel } from './OverridePanel';
import { ShopUpsertPanel } from './ShopUpsertPanel';
import { LocaleToggle } from './components/LocaleToggle';

type Panel = 'diff' | 'apply' | 'override' | 'shop-upsert';

interface Props {
  env: EnvSchema;
}

export function ActionBar({ env }: Props) {
  const [open, setOpen] = useState<Panel | null>(null);

  return (
    <div className="mb-3 flex gap-2 rounded-md border border-border bg-card px-3 py-2">
      <Button type="button" variant="outline" size="sm" onClick={() => setOpen('diff')}>
        Diff (preview)
      </Button>
      <Button type="button" variant="outline" size="sm" onClick={() => setOpen('apply')}>
        Apply ({env})
      </Button>
      <Button type="button" variant="outline" size="sm" onClick={() => setOpen('override')}>
        Override
      </Button>
      <Button type="button" variant="outline" size="sm" onClick={() => setOpen('shop-upsert')}>
        Shop Upsert
      </Button>
      <div className="ml-auto">
        <LocaleToggle />
      </div>
      {open === 'diff' && <DiffPanel env={env} onClose={() => setOpen(null)} />}
      {open === 'apply' && <ApplyPanel env={env} onClose={() => setOpen(null)} />}
      {open === 'override' && <OverridePanel onClose={() => setOpen(null)} />}
      {open === 'shop-upsert' && <ShopUpsertPanel onClose={() => setOpen(null)} />}
    </div>
  );
}
